// extracted by mini-css-extract-plugin
export default {"blogContainer":"BlogContent_blogContainer__1SGfW"};